import { IAnalysisSet } from '@/types/Analysis/AnalysisSets.types';

export default function updateTabTitle(
  activeSample?: Partial<Pick<IAnalysisSet, 'patientId' | 'sequencedEvent'>>,
  ...pages: string[]
): void {
  const values: string[] = [];
  const env = import.meta.env.VITE_ENV;

  if (env && env !== 'production') {
    values.push(env[0].toUpperCase() + env.slice(1));
  }

  if (activeSample?.patientId) {
    values.push(activeSample.patientId);
  }

  if (activeSample?.sequencedEvent) {
    values.push(activeSample.sequencedEvent);
  }

  document.title = [...values, ...pages.filter(Boolean), 'ZeroDash'].join(' - ');
}
